var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3637 19C13.2707 19 13.1776 18.9645 13.1066 18.8935C12.9645 18.7514 12.9645 18.5213 13.1066 18.3793L16.4858 15L13.1066 11.6207C12.9645 11.4786 12.9645 11.2485 13.1066 11.1065C13.2487 10.9645 13.4788 10.9644 13.6208 11.1065L17.2571 14.7429C17.3992 14.885 17.3992 15.1151 17.2571 15.2571L13.6208 18.8935C13.5498 18.9645 13.4567 19 13.3637 19Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderBtn);
export default __webpack_public_path__ + "static/media/slider-btn.d5a6552bb6c1ddcc1c582b6beff03419.svg";
export { ForwardRef as ReactComponent };